export default __webpack_public_path__ + "static/media/welcomeMessage.843ce89f.png";